const stateMap: { [key: string]: string } = {
  "US-AL": "Alabama",
  "US-AK": "Alaska",
  "US-AZ": "Arizona",
  "US-AR": "Arkansas",
  "US-CA": "California",
  "US-CO": "Colorado",
  "US-CT": "Connecticut",
  "US-DE": "Delaware",
  "US-FL": "Florida",
  "US-GA": "Georgia",
  "US-HI": "Hawaii",
  "US-ID": "Idaho",
  "US-IL": "Illinois",
  "US-IN": "Indiana",
  "US-IA": "Iowa",
  "US-KS": "Kansas",
  "US-KY": "Kentucky",
  "US-LA": "Louisiana",
  "US-ME": "Maine",
  "US-MD": "Maryland",
  "US-MA": "Massachusetts",
  "US-MI": "Michigan",
  "US-MN": "Minnesota",
  "US-MS": "Mississippi",
  "US-MO": "Missouri",
  "US-MT": "Montana",
  "US-NE": "Nebraska",
  "US-NV": "Nevada",
  "US-NH": "New Hampshire",
  "US-NJ": "New Jersey",
  "US-NM": "New Mexico",
  "US-NY": "New York",
  "US-NC": "North Carolina",
  "US-ND": "North Dakota",
  "US-OH": "Ohio",
  "US-OK": "Oklahoma",
  "US-OR": "Oregon",
  "US-PA": "Pennsylvania",
  "US-RI": "Rhode Island",
  "US-SC": "South Carolina",
  "US-SD": "South Dakota",
  "US-TN": "Tennessee",
  "US-TX": "Texas",
  "US-UT": "Utah",
  "US-VT": "Vermont",
  "US-VA": "Virginia",
  "US-WA": "Washington",
  "US-WV": "West Virginia",
  "US-WI": "Wisconsin",
  "US-WY": "Wyoming",
  "US-DC": "District of Columbia",
  "US-AS": "American Samoa",
  "US-GU": "Guam",
  "US-MP": "Northern Mariana Islands",
  "US-PR": "Puerto Rico",
  "US-UM": "United States Minor Outlying Islands",
  "US-VI": "Virgin Islands, U.S.",
  "PR-U-A": "Puerto Rico",
  "VI-U-A": "Virgin Islands",
  Alabama: "US-AL",
  Alaska: "US-AK",
  Arizona: "US-AZ",
  Arkansas: "US-AR",
  California: "US-CA",
  Colorado: "US-CO",
  Connecticut: "US-CT",
  Delaware: "US-DE",
  Florida: "US-FL",
  Georgia: "US-GA",
  Hawaii: "US-HI",
  Idaho: "US-ID",
  Illinois: "US-IL",
  Indiana: "US-IN",
  Iowa: "US-IA",
  Kansas: "US-KS",
  Kentucky: "US-KY",
  Louisiana: "US-LA",
  Maine: "US-ME",
  Maryland: "US-MD",
  Massachusetts: "US-MA",
  Michigan: "US-MI",
  Minnesota: "US-MN",
  Mississippi: "US-MS",
  Missouri: "US-MO",
  Montana: "US-MT",
  Nebraska: "US-NE",
  Nevada: "US-NV",
  "New Hampshire": "US-NH",
  "New Jersey": "US-NJ",
  "New Mexico": "US-NM",
  "New York": "US-NY",
  "North Carolina": "US-NC",
  "North Dakota": "US-ND",
  Ohio: "US-OH",
  Oklahoma: "US-OK",
  Oregon: "US-OR",
  Pennsylvania: "US-PA",
  "Rhode Island": "US-RI",
  "South Carolina": "US-SC",
  "South Dakota": "US-SD",
  Tennessee: "US-TN",
  Texas: "US-TX",
  Utah: "US-UT",
  Vermont: "US-VT",
  Virginia: "US-VA",
  Washington: "US-WA",
  "West Virginia": "US-WV",
  Wisconsin: "US-WI",
  Wyoming: "US-WY",
  "District of Columbia": "US-DC",
  "American Samoa": "US-AS",
  Guam: "US-GU",
  "Northern Mariana Islands": "US-MP",
  "Puerto Rico": "US-PR",
  "United States Minor Outlying Islands": "US-UM",
  "Virgin Islands: U.S.": "US-VI",
  AA: "American Airlines",
  DL: "Delta Air Lines",
  UA: "United Airlines",
  HP: "America West Airlines",
  NW: "Northwest Airlines",
  WN: "Southwest Airlines",
  US: "US Airways",
  CO: "Continental Airlines",
  AS: "Alaska Airlines",
  MQ: "American Eagle Airlines"
};

export default stateMap;
